import { render, staticRenderFns } from "./HorizontalDocumentTabs.vue?vue&type=template&id=1cfe190b&scoped=true&"
import script from "./HorizontalDocumentTabs.vue?vue&type=script&lang=ts&"
export * from "./HorizontalDocumentTabs.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalDocumentTabs.vue?vue&type=style&index=0&id=1cfe190b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe190b",
  null
  
)

export default component.exports